import { render, staticRenderFns } from "./waiting_approval.vue?vue&type=template&id=853ae51e&scoped=true"
import script from "./waiting_approval.vue?vue&type=script&lang=js"
export * from "./waiting_approval.vue?vue&type=script&lang=js"
import style0 from "./waiting_approval.vue?vue&type=style&index=0&id=853ae51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853ae51e",
  null
  
)

export default component.exports